module.exports = __webpack_public_path__ + "img/colorful-pills-wooden-spoons.a93f9e50.jpeg";